import { binarySearch } from '../binary-search'

export function insertAtStore <T, P extends keyof T> (arr: T[], item: T, field: P) {
  const result = binarySearch(arr, item[field], field)
  if (result < 0) {
    arr.splice(-result - 1, 0, item)
  } else {
    arr.splice(result, 1, item)
  }
}
